"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLogHandler = exports.flushBuffer = void 0;
const detect_browser_1 = require("detect-browser");
const log_formatter_1 = require("./log.formatter");
const log_sender_1 = require("./log.sender");
const logger_interface_1 = require("./logger.interface");
const utils_1 = require("./utils");
let logsBuffer = [];
const addLogToBuffer = (logLevel, message, log) => {
    logsBuffer.push({ logLevel, log, message });
};
const flushBuffer = (data, isKeepalive = false) => {
    logsBuffer.forEach(({ logLevel, log, message }) => {
        print(data, logLevel, message, log);
    });
    logsBuffer = [];
    (0, log_sender_1.sendLogsToServer)(data.config, isKeepalive);
};
exports.flushBuffer = flushBuffer;
const print = (data, logLevel, message, log) => {
    const { config, merchantName } = data;
    const browser = (0, detect_browser_1.detect)();
    const formattedLog = (0, log_formatter_1.format)(Object.assign(Object.assign({}, log), { browserSessionId: config.browserSessionId, deviceSessionId: config.deviceSessionId, correlationId: config.correlationId, browserName: browser === null || browser === void 0 ? void 0 : browser.name, browserVersion: browser === null || browser === void 0 ? void 0 : browser.version, sessionId: config.sessionId, appName: config.appName, merchantName,
        message }));
    // print the log to the console
    if ((!config.production ||
        [logger_interface_1.LogLevel.ERROR, logger_interface_1.LogLevel.FATAL].includes(logLevel)) &&
        formattedLog.console) {
        const logType = logger_interface_1.LogsType[logLevel];
        utils_1.refConsole[logType](...formattedLog.console);
    }
    // sends the log to the server
    if (formattedLog.server) {
        (0, log_sender_1.handleServerLogs)(config, logLevel, formattedLog.server);
    }
};
const makeLogHandler = (logLevel, getData) => {
    return (message, log) => {
        const data = getData();
        const { config, isInitialized } = data;
        if (!isInitialized) {
            utils_1.refConsole.error(`Logger is not initialized, called console.${logger_interface_1.LogsType[logLevel]} with message:`, message, 'and log data:', log);
        }
        if (!log || !log.filename || !log.function) {
            throw new Error('Log data is required');
        }
        if ([logger_interface_1.LogLevel.ERROR, logger_interface_1.LogLevel.FATAL].includes(logLevel)) {
            console.error(new Error(message), (0, log_formatter_1.filterProps)(true, log));
        }
        else {
            if ((typeof message !== 'string' &&
                message.printOriginalToConsole) ||
                log.printOriginalToConsole) {
                const newArgs = (0, log_formatter_1.filterProps)(true, log);
                const logType = logger_interface_1.LogsType[logLevel];
                utils_1.refConsole[logType](message, ...Object.values(newArgs));
            }
        }
        const logData = {
            message,
            log: Object.assign(Object.assign({}, log), { timestamp: Date.now() }),
        };
        if ((!config.browserSessionId && !config.sessionId) || !isInitialized) {
            return addLogToBuffer(logLevel, message, logData.log);
        }
        print(data, logLevel, message, logData.log);
    };
};
exports.makeLogHandler = makeLogHandler;
